import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';

class SideBarProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  processStatus = status =>
    status
      ? status === 'blacklisted'
        ? 'suspended'
        : status.split('_').join(' ')
      : '';

  getStatusColor = status => {
    switch (status) {
      case 'signed_up':
      case 'operating':
        return '#128DFF';
      case 'subscribed':
        return '#767676';
      case 'negative_balance':
        return '#FF0000';
      case 'closed':
        return '#767676';
      default:
        return '#767676';
    }
  };
  render() {
    const {
      firstName,
      status,
      profileImage,
      profileButton,
      onClick = () => {}
    } = this.props;
    return (
      <Fragment>
        <img
          onClick={onClick}
          className="sidebar__profile--image"
          style={{
            border: `solid 2px ${this.getStatusColor(status)}`,
            cursor: 'pointer'
          }}
          src={profileImage}
          alt="status"
        />
        <div className="sidebar__profile--info">
          <div
            className="sidebar__profile--first-name"
            style={{ cursor: 'pointer' }}>
            {firstName}
          </div>
          <div className="sidebar__profile--status">
            Status: {this.processStatus(status)}
          </div>
          {profileButton ? (
            <div className="sidebar__profile--view" onClick={onClick}>
              View Profile{' '}
            </div>
          ) : null}
        </div>
      </Fragment>
    );
  }
}

export default withRouter(SideBarProfile);



// WEBPACK FOOTER //
// ./src/components/SideBar/SideBarProfile.js